export const PAYER_REGISTRATION='PAYER_REGISTRATION';
export const PAYER_SEARCH = 'PAYER_SEARCH';
export const EXISTING_PAYER_LIST = 'EXISTING_PAYER_LIST';
export const PAYER_SEARCH_VIEW = 'PAYER_SEARCH_VIEW';
export const PAYER_STATUS_UPDATE = 'PAYER_STATUS_UPDATE';
export const RESET_PAYER_STATUS = 'RESET_PAYER_STATUS';
export const UNAPPROVED_PAYERS = 'UNAPPROVED_PAYERS';